import { useT, useLanguage } from "../../i18n/hooks.ts";

const LEGAL_URL_ES = "https://www.aemet.es/es/nota_legal";
const LEGAL_URL_EN = "https://www.aemet.es/en/nota_legal";

/**
 * Formal attribution for AEMET OpenData, shown for as long as
 * AemetFetchDialog.tsx is open — same "this is the citation, not just a
 * courtesy credit" spirit as MitecoAttributionBanner.tsx. AEMET's own terms
 * (Ley 18/2015, their own "Nota legal") authorize reuse conditional on
 * citing AEMET as the author of the information — confirmed against
 * opendata.aemet.es/centrodedescargas/info's own footer text.
 */
export function AemetAttributionNotice() {
  const t = useT();
  const language = useLanguage();
  return (
    <p className="muted-text">
      {t("aemetDialog.legalNotice")}{" "}
      <a
        href={language === "es" ? LEGAL_URL_ES : LEGAL_URL_EN}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("aemetDialog.viewLegalNotice")}
      </a>
    </p>
  );
}
